import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class CategoriesService {

	constructor(private readonly http : HttpClient) { }

	getDetails(): Observable<any> {
		const httpCustomOptions = {
			headers: new HttpHeaders({
				'Content-Type': 'application/json, application/x-www-form-urlencoded;charset=ISO-8859-15',
				'Accept': 'application/json',
			})
		};
		return this.http
			.get(`${environment.baseAPIURL}/api/v1/categories`, httpCustomOptions)
			.pipe(
				tap(_ => this.log('data success')),
				catchError(this.handleError<any>('data fails'))
			);
	}


	deleteCategory(arrData: any): Observable<any> {
		return this.http
			// .delete(`/api/v1/categories/deleteCategories?categoryID=${arrData.categoryID}`, arrData)
			.delete(`${environment.baseAPIURL}/api/v1/categories/deleteCategories/${arrData.categoryID}`)
			.pipe(
				tap(_ => this.log('data delete success')),
				catchError(this.handleError<any>('data delete failed'))
			);
	}

	addCategory(arrData: any): Observable<any> {
		const headers = new HttpHeaders().set('Content-Type', 'application/json');
		return this.http
			.post(`${environment.baseAPIURL}/api/v1/categories/addCategories`, arrData, { headers, responseType: 'text' })
			.pipe(
				tap(_ => this.log('data inserted success')),
				catchError(this.handleError<any>('data insert failed'))
			);
	}


	editCategory(arrData: any): Observable<any> {
		return this.http
			.put(`${environment.baseAPIURL}/api/v1/categories/updateCategories`, arrData)
			.pipe(
				tap(_ => this.log('data inserted success')),
				catchError(this.handleError<any>('data insert failed'))
			);
	}



	private handleError<T>(_operation, result?: T) {
		return (error: any): Observable<T> => {
			console.info(error); // log to console instead
			return of(result as T);
		};
	}

	/** Log a message */
	private log(message: string) {
		console.info('Message: ' + message);
	}




}
